export default{
    logisticsServe:{
        Description:{
            title:'物流服务',
            module1:{
                title:'国内物流服务',
                text:'以智能技术为驱动，我们广泛汇聚国内丰富运力资源，公路运输网络纵横交错，车辆配置灵活多样。专为国内中小企业打造智能高效运输体验，从货物揽收、路线规划到精准配送，全链路保障服务一路相伴，让货物在国内畅行无忧。',
                btn:'进入物流服务平台',
                box1:{
                    title:'全球运力',
                    text:'凭借多元运输体系，打破地域藩篱，紧密牵系全球众多国家，驱动世界经济奔腾向前。'
                },
                box2:{
                    title:'全供应链解决方案',
                    text:'依托广泛的全球运力网络，从采购、仓储到配送，全程优化管理，利用数智技术实时监控，确保供应链高效、稳定、透明，助力企业全球业务畅行。'
                },
                box3:{
                    title:'多式联运',
                    text:'海陆空多式联运，搭建高效物流体系。海运稳载海量货物，陆运灵活集散，空运速达全球，优势互补，满足多元物流需求。'
                },
                box4:{
                    title:'连接产区 直达全国',
                    text:'覆盖全国90%以上农产品产区，直达全国80%以上城市，从同城短途到跨城长途都能发。'
                },
                box5:{
                    title:'海量认证司机',
                    text:'完成海量认证大车司机，专业运输有保障，高效便捷，服务全国优质农产品运输。'
                },
                box6:{
                    title:'万级活跃车辆 车型齐全',
                    text:'活跃车辆超过万辆，车型从高栏、平板到厢货，车型全覆盖；从面包车、4米2到17米5，大小车全都有，满足货主用车需求。'
                },
            },
            module2:{
                title:'跨境物流服务',
                text:'以数智技术为内核，提供全球多样化的运力资源，智能高效的产品体验，以及全链路丰富的保障服务，帮助跨境B2B中小企业轻松运全球。',
            },
        },
    }
}